import {
	checkForPendingUploads,
	SingleFileUploadComponent
} from "../../helpers/inputs/singleFileUpload/SingleFileUploadComponent";
import Axios from "axios";

function initPublicFreightsAttachmentsView() {
	// Init file uploads
	const authorityFileUpload = new SingleFileUploadComponent(
		document.querySelector('.authority-upload-container'),
		{
			onUpload: () => {
				storeMediaSilently(
					document.querySelector('input[name="store_authority_attachment_route"]').value,
					authorityFileUpload.getFileId(),
				)
			}
		}
	);

	const w9Upload = new SingleFileUploadComponent(
		document.querySelector('.w_9-upload-container'),
		{
			onUpload: () => {
				storeMediaSilently(
					document.querySelector('input[name="store_w_9_attachment_route"]').value,
					w9Upload.getFileId(),
				)
			}
		}
	);

	const confirmUploadsButton = document.querySelector('.confirm-upload-button');

	// Need to force disable or the browser may remember it enabled
	confirmUploadsButton.disabled = true;
	confirmUploadsButton.addEventListener('click', confirmUploads);

	/** Methods */

	function storeMediaSilently($route, mediaId) {
		Axios.post(
			$route, {
				media_id: mediaId
			}
		)
			.then(enableConfirmButtonIfReady)
			.catch(console.error)
	}

	/**
	 * Enables confirm upload button if both uploads are done
	 */
	function enableConfirmButtonIfReady() {
		// Get file Ids
		const w9FileUploadId = w9Upload.getFileId();
		const authorityFileUploadId = authorityFileUpload.getFileId();

		// Enable button if both exists
		if (w9FileUploadId && authorityFileUploadId) {
			confirmUploadsButton.disabled = false;
			confirmUploadsButton.title = '';
		}
	}

	function confirmUploads() {
		checkForPendingUploads(document.body)
			.then(() => {
				window.location = document.querySelector('input[name="success_route"]').value;
			})
	}
}

export {initPublicFreightsAttachmentsView}
